<template>
  <b-sidebar
    id="add-new-category-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="showAddUserSidebar($event)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ category.id === null ? 'Adicionar nova' : 'Atualizar'}} categoria
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="Nome"
            rules="required"
          >
            <b-form-group
              label="Nome"
              label-for="name_category"
            >
              <b-form-input
                id="name_category"
                v-model="category.nome"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] ? 'Nome da categoria é obrigatório' : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-group>
            <label for="textarea-default">Descrição</label>
            <b-form-textarea
                id="textarea-descricao"
                v-model="category.descricao"
                placeholder="Breve descrição da categoria"
                rows="3"
                no-resize
            />
          </b-form-group>

          <validation-provider
            #default="validationContext"
            name="Ativo"
          >
            <b-form-group
              label="Status"
              label-for="category_active"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="category.ativo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Ativo', value: 1 },
                  { label: 'Inativo', value: 0 },
                ]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="category_active"
              />
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ category.id === null ? 'Adicionar' : 'Atualizar' }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>

  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { computed } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {useToast} from "vue-toastification/composition";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-usuarios-sidebar-active',
  },
  props: {
    blankGrupoData: {
      type: Object,
      required: true,
    },
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  methods: {
    showAddUserSidebar(e) {
      this.$emit('input', e)
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const category = computed({
      get: () => {
        if (props.blankGrupoData) {
          return JSON.parse(JSON.stringify(props.blankGrupoData))
        }
        return JSON.parse(JSON.stringify(props.blankGrupoData))
      },
      set: val => {
        emit('update:blankGrupoData', val)
      },
    })
    const resetcategory = () => {
      category.value = JSON.parse(JSON.stringify(category.value))
    }

    const onSubmit = () => {
      if (category.value.id === null) {
        store.dispatch('appAdmCategory/addCategory', {
          ...category.value,
        })
          .then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Sucesso',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Categoria cadastrada com sucesso',
              },
            })
            emit('refetch-data')
            emit('input', false)
          })
        return
      }

      store.dispatch('appAdmCategory/updatedCategory', {
        ...category.value,
      })
        .then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Categoria atualizada com sucesso',
            },
          })
          emit('refetch-data')
          emit('input', false)
        })
    }

    const {
      fetchGrupos,
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetcategory)

    return {
      fetchGrupos,
      category,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-category-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
